import { cn } from "@repo/shared/utils";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

export interface DynamicFormikCollapsibleSectionProps {
  title?: string;
  defaultCollapsed?: boolean;
  children?: React.ReactNode;
}

export const DynamicFormikCollapsibleSection = ({
  title = "",
  defaultCollapsed = true,
  children = null,
}: DynamicFormikCollapsibleSectionProps) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div className="border rounded-md border-slate-300 overflow-hidden">
      <p
        className="p-4 cursor-pointer bg-slate-300 flex justify-between"
        onClick={() => setCollapsed(!collapsed)}
      >
        {title}
        <ChevronDown
          className={cn(
            "transition-transform duration-300",
            collapsed ? "" : "rotate-180"
          )}
        />
      </p>
      <div
        className={cn("flex flex-col gap-y-4 p-2", collapsed ? "hidden" : "")}
      >
        {children}
      </div>
    </div>
  );
};
